import React, { Fragment } from "react";

export default function CouponSupportType({ coupon }) {
  let supportMinutes: any = [];
  for (const lst of coupon.availableProductList) {
    if (lst.productType == "SUPPORT") {
      supportMinutes.push(lst.minutesToSupport);
    }
  }
  return (
    <Fragment>
      {coupon.availableProductList.map((list, id) => {
        return (
          <Fragment key={id}>
            {list.productType == "INTERVIEW" && <span>問診チケット</span>}
            {list.productType == "TIP" && <span>チップ</span>}
          </Fragment>
        );
      })}
      {supportMinutes.length > 0 && (
        <span>
          サポートチケット{" "}
          {supportMinutes.map((min, index) => (
            <Fragment key={index}>
              {min}分{index < supportMinutes.length - 1 ? "," : ""}
            </Fragment>
          ))}
        </span>
      )}
    </Fragment>
  );
}
